import pagesConfig from '../pages/config';

export default {
    type: 'news-and-views',
    relations: pagesConfig.relations,
    composes: [
        'news',
        'blog-posts',
        'podcasts'
    ],
    components: {
        webRecord: {
            name: 'DisplayNewsAndViewsRecord',
            loader: () => import('./DisplayNewsAndViewsRecord')
        }
    },
}
